import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className='bg-dark-lighter border-t border-dark-darker'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>
          {/* About Section */}
          <div>
            <Link to='https://rgmeds.com/' className='flex items-center gap-2'>
              <img src='logo.png?v=1.0' alt='MediVerify' className='h-8 w-auto' />
              <span className='text-light-darker font-bold text-xl tracking-wide'></span>
            </Link>
            <h3 className='text-lg font-bold text-red-400 mb-4'>About Us</h3>
            <p className='text-light-darkest text-sm leading-relaxed'>
              RG Meds ensures the authenticity of your products using advanced verification
              technology for safer healthcare.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className='text-lg font-bold text-red-400 mb-4'>Quick Links</h3>
            <ul className='space-y-2 text-sm'>
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/privacy', label: 'Privacy Policy' },
                { to: '/terms', label: 'Terms & Conditions' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className='text-light-darker hover:text-red-400 transition-colors'
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className='text-lg font-bold text-red-400 mb-4'>Contact</h3>
            <ul className='space-y-3 text-sm text-light-darker'>
              <li className='flex'>
                <span className='w-20 font-medium text-secondary-light'>Email:</span>
                <span>info@rgmeds.com</span>
              </li>
              <li className='flex d-none'>
                <span className='w-20 font-medium text-secondary-light'>Phone:</span>
                <span>+1 (555) 123-4567</span>
              </li>
              <li className='flex d-none'>
                <span className='w-20 font-medium text-secondary-light'>Address:</span>
                <span>
                  123 Medical Plaza,
                  <br />
                  Healthcare City
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className='border-t border-dark-darker mt-10 pt-6 text-center'>
          <p className='text-sm text-light-darker'>
            &copy; {new Date().getFullYear()} <span className='text-red-400'>RG Meds</span>. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
